export const tabIds = {
  Overview: 'Overview',
  Details: 'Details',
  KeyDates: 'KeyDates'
}
export const facetTypes = {
  committee: 'committee',
  publicationType: 'publication-type',
  publicationStatus: 'publication-status'
}

export const dropdownFormControlNames = {
  committeeCtrl: 'committeeCtrl',
  publicationTypeDropdownCtrl: 'publicationTypeDropdownCtrl',
  publicationStatusDropdownCtrl: 'publicationStatusDropdownCtrl'
}

export const saLibraryPublicationCommitteeType = {
  allPublications: 'allPublications',
  myCommittee: 'myCommittee'
}


export const saLibraryPublicationTypes = {
  Standard: 'Standard',
  Amendment: 'Amendment',
  Reconfirmation: 'Reconfirmation',
  TechnicalSpecification: 'Technical Specification',
  TechnicalReport: 'Technical Report',
  Ruling: 'Ruling',
  Supplement: 'Supplement',
  InterimStandard: 'Interim Standard',
  Handbook: 'Handbook',
  OtherHistoricalPublication: 'Other (historical publication)',
  Other: 'Other',
  MiscellaneousPublication: 'Miscellaneous Publication',
  PubliclyAvailableSpecification: 'Publicly Available Specification'
};






